define('controllers/reviewacceptedvacations',['require'],function(require) {
    return function () {
        if (ServerData.feData.TrackBooked != null) {
            gaTrack('conversions', 'Booked', ServerData.feData.TrackBooked.MyDestinationID, ServerData.feData.TrackBooked.vacationValue);
        }

		window.validateCheckedPolicyAgreement = function(sender, args) {
			var chkCancelPolicy = $("#chkAgreeToPolicies");
			args.IsValid = chkCancelPolicy.length == 0 || chkCancelPolicy.is(':checked');
		}

		$(function () {
			var cameFromRoomSelection = document.referrer.indexOf("RoomSelection.aspx") != -1;
			if (cameFromRoomSelection) {
				$("#anchorReturnToRoomSelection").attr("href", "javascript:history.go(-1);");
			}

			//overages
			var selectAccountForTaxesPH = $("#selectAccountForTaxesPH");
			$("#payTaxesOptions input[type='radio']").on("change", function () {
				if ($("#payTaxesOptions input[type='radio']:checked").val() == "pto0") {
					selectAccountForTaxesPH.show();
				}
				else {
					selectAccountForTaxesPH.hide();
				}
			});

			var selectAccountForOveragePH = $("#selectAccountForOveragePH");
			$("#lowFundsOptions input[type='radio']").on("change", function () {
				if ($("#lowFundsOptions input[type='radio']:checked").val() == "lfo0") {
					selectAccountForOveragePH.show();
				} else {
					selectAccountForOveragePH.hide();
				}
			});

			var payTaxes = $("#payTaxes"),
				btnPayTaxes = $("#btnPayTaxes"),
				payTaxesDone = $("#payTaxesDone"),
				lowFunds = $("#lowFunds"),
				ButtonAddFunds = $("#ButtonAddFunds"),
				lowFundsDone = $("#lowFundsDone"),
				ButtonBookRoom = $("#ButtonBookRoom");


		    var WhatIsPaid = ServerData.feData.WhatIsPaid || {};

		    (WhatIsPaid.taxesPaid != undefined && (!WhatIsPaid.taxesPaid || !WhatIsPaid.overagePaid)) ? ButtonBookRoom.hide() : ButtonBookRoom.show();

			ButtonAddFunds.on("click", function () {
			    WhatIsPaid.overagePaid = true;
				lowFunds.slideUp('fast', function () {
					lowFundsDone.slideDown('fast', function () {
					    if (WhatIsPaid.taxesPaid) {
							ButtonBookRoom.fadeIn('slow');
						}
					});
				});
			});

			btnPayTaxes.on("click", function () {
			    WhatIsPaid.taxesPaid = true;
				payTaxes.slideUp('fast', function () {
					payTaxesDone.slideDown('fast', function () {
					    if (WhatIsPaid.overagePaid) {
							ButtonBookRoom.fadeIn('fast');
						}
					});
				});
			});

			//table toggles
			$("table.toggleBody thead").on("click", function () {
				var thead = $(this),
					icon = $("i", thead),
					downIcon = "icon-chevron-down",
					upIcon = "icon-chevron-up",
					opening = icon.hasClass(downIcon),
					addClass = opening ? upIcon : downIcon,
					removeClass = opening ? downIcon : upIcon;

				thead.next().toggle();
				icon.removeClass(removeClass).addClass(addClass);
			});

			//add extra text to info popups...
			$(".infoBox").each(function () {
				var $this = $(this);
				$this.html($this.html() + "<br /><br /><span class='sideNote'>More Questions? <a href='#' class='openOlark'>Chat with us!</a></span>");
			});

			ButtonBookRoom.on("click", function () {
				if (window.Page_ClientValidate == undefined || Page_ClientValidate('BookingValidation')) {
					$(this).hide();
					$('#loading').fadeIn('slow');
				}
			});
			Utilities.setDefaultButton($('#reviewBooking'), ButtonBookRoom);
		});
    };
});
